import Button, { EButtonSize, EButtonType } from "../Buttons/Button";
import "./PageNotFoundScreen.scss";
import React, { FC } from "react";

interface IPageNotFoundScreenProps {}

const PageNotFoundScreen: FC<IPageNotFoundScreenProps> = () => {
  const goBack = () => {
    window.history.back();
  }

  return (
    <div className="page-not-found-container">
      <div className="container-content">
        <h1>404 - Page Not Found</h1>
        <Button text="Go back" buttonType={EButtonType.SECONDARY} size={EButtonSize.NORMAL} onClick={goBack} />
      </div>
    </div>
  );
}

export default PageNotFoundScreen;